module.exports = __webpack_public_path__ + "static/media/little-debbie-conclusion-image.0076a5d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/OnboardingDemo/assets/little-debbie-conclusion-image.png
// module id = 1435
// module chunks = 0